import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Context } from '../../../contexts/Store';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

const IconContainer = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #fef2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
`;

const WarningIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: bold;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 12px 0;
`;

const Message = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

const Button = styled.button`
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;

  &:hover {
    background-color: #dc2626;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
  }
`;

const UserValidationModal = ({ isOpen, onClose, message = "Your account has been deactivated or deleted by admin." }) => {
  const navigate = useNavigate();
  const { dispatch } = React.useContext(Context);

  const handleLogout = () => {
    // Clear user data from context and localStorage
    dispatch({
      type: 'LOGOUT'
    });

    // Navigate to login page
    navigate('/?auth=login');
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <IconContainer>
          <WarningIcon>!</WarningIcon>
        </IconContainer>
        <Title>Account Deactivated</Title>
        <Message>{message}</Message>
        <Button onClick={handleLogout}>
          Return to Login
        </Button>
      </ModalContent>
    </ModalOverlay>
  );
};

export default UserValidationModal;
